import React from 'react'
import { useParams, useLocation, useNavigate } from 'react-router'

// Wrapper functional component because react-router v7 doesn't support this automatically anymore
export const routerProps = WrappedComponent => {
  const RouterPropsWrapper = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()

    return (
      <WrappedComponent
        date={params.date}
        location={location}
        navigate={navigate}
      />
    )
  }
  return RouterPropsWrapper
}
